import { PhaseKind } from '../data/protocols';
import { VoiceClip } from '../data/soundscapes';

const clamp01 = (n: number): number => Math.min(Math.max(n, 0), 1);

export function natureGainFor(balance: number): number {
  return clamp01(balance);
}

// Multiplier applied to the binaural bed when a nature sound is active.
// Never fully mutes, so the binaural entrainment persists on headphones.
export function bedScaleFor(balance: number): number {
  return 1 - 0.65 * clamp01(balance);
}

export function voiceClipFor(kind: PhaseKind): VoiceClip {
  if (kind === 'inhale') return 'inhale';
  if (kind === 'exhale') return 'exhale';
  return 'hold'; // holdIn, holdOut
}
